var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "root-component-container pattern-background-purple" },
    [
      _c(
        "v-container",
        { staticClass: "fill-height", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { staticClass: "justify-center" },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex justify-end",
                  attrs: { cols: "10", md: "6", xl: "4" },
                },
                [_c("AccountOptionsBar", { attrs: { light: "" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "justify-center fill-height" },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex flex-column fill-height",
                  attrs: { cols: "10", md: "6", xl: "4" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex-grow-1 d-flex justify-center align-center",
                    },
                    [
                      _c("v-img", {
                        staticClass: "fade-15",
                        attrs: {
                          src: "/quickytools.svg",
                          "max-width":
                            _vm.$vuetify.breakpoint.width < 400 ? 128 : 256,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("MailingListDialog", {
        attrs: {
          "list-key": "day6-marketing",
          title: _vm.day6Resource.day6Updates,
        },
        model: {
          value: _vm.showMailingListDialog,
          callback: function ($$v) {
            _vm.showMailingListDialog = $$v
          },
          expression: "showMailingListDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }